export default __webpack_public_path__ + "static/media/Thumb-3.db409390.png";